import { inject, Injector, ProviderToken, Service } from '@angular/core';
import { Resettable, IResettable } from '@portal-core/util/resettable.decorator';

@Service()
export class ResettableService {
  private readonly injector = inject(Injector);

  // Returns all the injectables from providers that use the @Resettable decorator
  getResettables(): IResettable[] {
    // Each entry is really a class token (the decorator stores constructors as IResettable); resolve
    // it back to its injected instance.
    return Resettable.resettables.map(resettable => this.injector.get<IResettable>(resettable as unknown as ProviderToken<IResettable>));
  }
}
